import { and, asc, eq } from "drizzle-orm";
import { employee, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveEmployeeFilters } from "../live/filters";

/** Active employees of org, sorted by name. */
export function getEmployeesQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(employee)
    .where(and(eq(employee.organization_id, organizationId), ...liveEmployeeFilters()))
    .orderBy(asc(employee.name));
}
